import React, { useState, useEffect } from "react"

import Content from "./payment_form/content"
import Loading from "./payment_form/loading"

import useFetch from "hooks/use-new-fetch"
import usePromoCode from "hooks/use-promo-code"

export default function PaymentForm({
  billingCycle = "year",
  plans,
  handleSubscription,
  onPlanChange,
  modalOptions,
  options
}) {
  const [data, setData] = useState(null)
  const [request, loading] = useFetch("/onboarding/payment_form")

  const { promoCode, promoCodeLoaded } = usePromoCode()

  const fetchData = async () => {
    const response = await request.get({ path: `?promo_code=${promoCode}` })
    setData(response.data)
  }

  useEffect(() => {
    if (!promoCodeLoaded) return

    fetchData()
  }, [promoCode, promoCodeLoaded])

  return (
    <>
      {!data && loading && <Loading />}

      {!!data && !loading && (
        <Content
          handleSubscription={handleSubscription}
          onPlanChange={onPlanChange}
          billingCycle={billingCycle}
          stripeData={data.stripe_data}
          currentPlans={plans || data.current_plans}
          trialPeriodEnd={data.trial_period_end}
          trialing={data.trialing}
          currentlyOnFreePlan={data.free_plan}
          modalOptions={modalOptions}
          options={options}
        />
      )}
    </>
  )
}
